import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import ExternalApplicationForm from './ExternalApplicationForm';

export class ExternalApplicationUpdateForm extends FormView {
    protected getFormComponent() {
        return ExternalApplicationForm as any;
    }
}

export default ExternalApplicationUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(ExternalApplicationUpdateForm));
